export default {
	computed: {
		productSheetDesignConfig() {
			let config = this.$srv('productSheetDesign')
			if (!config) return

			let found
			if (config.collections?.length) {
				found = config.collections.find((item) => {
					return this.product.collectionsIds.some((id) => id == item.collectionId)
				})
			}
			if (found) return found
			else return config
		},
		psdConfig() {
			const configs = this.$srv('productSheetDesign')
			if (!this.product || !configs?.length) return null
			for (const config of configs) {
				if (!config.collectionId) return config
				if (this.product.collectionsIds.some((id) => id == config.collectionId)) {
					return config
				}
			}
			return null
		},
		psdDesign() {
			return this.psdConfig?.design || 'default'
		},
		psdShowReadMoreButton() {
			return this.psdConfig?.showReadMoreButton
		},
		psdEnableDesktopZoom() {
			return this.psdConfig?.enableDesktopZoom
		},
	},
}

